function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;
Object.defineProperty(exports, "SelectType", {
  enumerable: true,
  get: function get() {
    return _styles.SelectType;
  }
});
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _reactNativeElementDropdown = require("react-native-element-dropdown/lib/commonjs");
var _Field = require("../Field");
var _styles2 = require("../../styles");
var Icons = _interopRequireWildcard(require("../Icons"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["items", "label", "onSelect", "disabled", "selectedId", "emptyLabel", "type"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var Select = exports.Select = (0, _react.memo)(function (_ref) {
  var items = _ref.items,
    label = _ref.label,
    onSelect = _ref.onSelect,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    selectedId = _ref.selectedId,
    emptyLabel = _ref.emptyLabel,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? _styles.SelectType.normal : _ref$type,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useStyles = (0, _styles.useStyles)({
      type: type
    }),
    styles = _useStyles.styles;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    focused = _STYLES$useStyles.focused,
    COLORS = _STYLES$useStyles.COLORS;
  var _ref2 = focused,
    outlineColor = _ref2.outlineColor,
    outlineWidth = _ref2.outlineWidth,
    outlineStyle = _ref2.outlineStyle;
  var _useState = (0, _react.useState)(selectedId),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isFocus = _useState4[0],
    setIsFocus = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    _keyboardMetrics = _useState6[0],
    _setKeyboardMetrics = _useState6[1];
  var _useState7 = (0, _react.useState)('bottom'),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    _dropdownPosition = _useState8[0],
    _setDropdownPosition = _useState8[1];
  var _containerRef = (0, _react.useRef)(null);
  var _flatListProps = {};
  var _listBottom = (0, _react.useRef)(0);
  var _dropdownRef = (0, _react.useRef)(null);
  _flatListProps.onLayout = function (_ref3) {
    var _containerRef$current;
    var layout = _ref3.nativeEvent.layout;
    (_containerRef$current = _containerRef.current) == null ? void 0 : _containerRef$current.measure(function (_x, _y, _width, _height, _pageX, pageY) {
      var _containerBottom = pageY || 0;
      var _listMargin = 24;
      var _buffer = 20;
      _listBottom.current = _containerBottom + _listMargin + layout.height + _buffer;
      if (_listBottom.current > _reactNative.Dimensions.get('window').height) {
        _setDropdownPosition('top');
      } else {
        _setDropdownPosition('bottom');
      }
    });
  };
  var data = (0, _react.useMemo)(function () {
    return items.map(function (item) {
      return {
        value: item.value || item.id || '',
        label: item.label
      };
    });
  }, [items]);
  var _webInit = (0, _react.useCallback)(function () {
    if (document.getElementById('Select_styles') !== null) return;
    var _style = document.createElement('style');
    _style.id = 'Select_styles';
    _style.appendChild(document.createTextNode("\n          [data-testid=\"Select\"] [data-testid=\"Label\"] + div:focus-within,\n          div[tabindex=\"0\"]:has([data-testid^=\"SelectList\"][data-testid$=\"flatlist\"]):focus-visible,\n          div[tabindex=\"0\"]:has([data-testid^=\"SelectList\"][data-testid$=\"flatlist\"]) > [tabindex=\"0\"]:focus-within,\n          [data-testid^=\"SelectList\"][data-testid$=\"flatlist\"] [tabindex=\"0\"]:focus-visible {\n            outline-color: ".concat(outlineColor, ";\n            outline-width: ").concat(outlineWidth, ";\n            outline-style: ").concat(outlineStyle, ";\n            border-radius: 1.25rem;\n          }\n\n          [data-testid^=\"SelectList\"][data-testid$=\"flatlist\"] [tabindex=\"0\"]:focus-visible {\n            outline-offset: -8px;\n          }\n\n          [data-testid=\"SelectList\"]:focus-visible,\n          div[tabindex=\"0\"]:has([data-testid^=\"SelectList\"][data-testid$=\"flatlist\"]) > [tabindex=\"0\"] input:focus-visible {\n            outline: 0;\n          }\n\n          [data-testid^=\"SelectList\"][data-testid$=\"flatlist\"]::-webkit-scrollbar {\n            width: 0.375rem;\n          }\n\n          [data-testid^=\"SelectList\"][data-testid$=\"flatlist\"]::-webkit-scrollbar-track {\n            margin: 0.9rem 0;\n          }\n\n          [data-testid^=\"SelectList\"][data-testid$=\"flatlist\"]::-webkit-scrollbar-thumb {\n            background-color: #888888;\n            outline: 0;\n            border-radius: 0.1875rem;\n          }\n        ")));
    document.head.appendChild(_style);
  }, [outlineColor, outlineStyle, outlineWidth]);
  var _hideDropdown = function _hideDropdown() {
    var _dropdownRef$current;
    (_dropdownRef$current = _dropdownRef.current) == null ? void 0 : _dropdownRef$current.close();
  };
  (0, _react.useEffect)(function () {
    if (_reactNative.Platform.OS === 'web') {
      _webInit();
    }
  }, [_webInit]);
  (0, _react.useEffect)(function () {
    var _keyboardDidShowListener = _reactNative.Keyboard.addListener('keyboardDidShow', function (event) {
      _setKeyboardMetrics(event.endCoordinates);
    });
    var _keyboardDidHideListener = _reactNative.Keyboard.addListener('keyboardDidHide', function () {
      _setKeyboardMetrics(undefined);
    });
    if (_reactNative.Platform.OS === 'web') {
      window.addEventListener('scroll', _hideDropdown);
    }
    return function () {
      _keyboardDidShowListener.remove();
      _keyboardDidHideListener.remove();
      if (_reactNative.Platform.OS === 'web') {
        window.removeEventListener('scroll', _hideDropdown);
      }
    };
  }, []);
  return (0, _jsxRuntime.jsxs)(_Field.Field, Object.assign({
    testID: "Select",
    label: label
  }, props, {
    children: [(0, _jsxRuntime.jsx)(_reactNativeElementDropdown.Dropdown, {
      ref: _dropdownRef,
      style: [styles.dropdown, isFocus && focused],
      selectedTextStyle: styles.selectedTextStyle,
      inputSearchStyle: styles.inputSearchStyle,
      containerStyle: [styles.list, !!_keyboardMetrics && _listBottom.current > _keyboardMetrics.screenY && {
        position: 'absolute',
        bottom: _keyboardMetrics.height
      }],
      itemTextStyle: styles.listItem,
      data: data,
      search: data.length > 20,
      maxHeight: 300,
      labelField: "label",
      valueField: "value",
      placeholder: emptyLabel,
      placeholderStyle: styles.placeholder,
      searchPlaceholder: "Search",
      value: value,
      onFocus: function onFocus() {
        return setIsFocus(true);
      },
      onBlur: function onBlur() {
        return setIsFocus(false);
      },
      onChange: function onChange(item) {
        setValue(item.value);
        setIsFocus(false);
        onSelect == null ? void 0 : onSelect(item.value);
      },
      disable: disabled,
      renderRightIcon: function renderRightIcon() {
        return (0, _jsxRuntime.jsx)(Icons.DownChevron, {
          color: COLORS.aubergine,
          style: styles.icon
        });
      },
      testID: "SelectList ".concat(label),
      activeColor: COLORS.mischka,
      flatListProps: _flatListProps,
      dropdownPosition: _dropdownPosition,
      inverted: false,
      keyboardAvoiding: false,
      autoScroll: false,
      showsVerticalScrollIndicator: true
    }), (0, _jsxRuntime.jsx)(_reactNative.View, {
      ref: _containerRef,
      collapsable: false
    })]
  }));
});